var _g, _g2, _g3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStack(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 386.617 386.617",
    style: {
      enableBackground: "new 0 0 386.617 386.617"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.869,84.591L228.748,9.142c-19.564-12.187-51.306-12.192-70.879,0L36.748,84.591 c-19.564,12.187-19.573,31.96,0,44.152l121.121,75.449c19.564,12.187,51.306,12.192,70.879,0l121.121-75.449 C369.433,116.556,369.442,96.783,349.869,84.591z M211.584,168.669c-9.98,6.333-26.202,6.307-36.14,0l-97.578-61.923 l97.578-61.734c9.98-6.314,26.202-6.287,36.14,0l97.578,61.734L211.584,168.669z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.869,172.542l-2.527-1.574l-127.273,80.305l-0.047-0.007l-8.438,5.354c-9.98,6.333-26.202,6.307-36.14,0 l-97.578-61.923l0.022-0.014l-38.131-24.017l-3.01,1.875c-19.564,12.187-19.573,31.96,0,44.152l121.121,75.449 c19.564,12.187,51.306,12.192,70.879,0l121.121-75.449C369.433,204.507,369.442,184.734,349.869,172.542z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.869,257.875l-2.527-1.574l-127.273,80.305l-0.047-0.007l-8.438,5.354c-9.98,6.333-26.202,6.307-36.14,0 L77.867,280.03l0.022-0.014L39.758,256l-3.01,1.875c-19.564,12.187-19.573,31.96,0,44.152l121.121,75.449 c19.564,12.187,51.306,12.192,70.879,0l121.121-75.449C369.433,289.84,369.442,270.067,349.869,257.875z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.e2c89ff678efbf1fd408bf4563900ab2.svg";
export { ForwardRef as ReactComponent };